import React from "react";
import { notifyError } from "../utils/bugsnag";

// Reports are throttled per error message: this boundary auto-recovers by
// remounting its children, so a deterministic crash re-throws every frame —
// without throttling that would flood Bugsnag.
const REPORT_THROTTLE_MS = 30000;
let lastReport = { message: null, time: 0 };

export default class RecoverableBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.warn("RecoverableBoundary caught error, remounting:", error.message);

    const now = Date.now();
    const isDuplicate =
      error.message === lastReport.message &&
      now - lastReport.time < REPORT_THROTTLE_MS;

    if (!isDuplicate) {
      lastReport = { message: error.message, time: now };
      notifyError(error, (event) => {
        event.context = "RecoverableBoundary";
        event.addMetadata("react", { componentStack: info?.componentStack });
      });
    }
  }

  componentDidUpdate(_, prevState) {
    if (this.state.hasError && !prevState.hasError) {
      // Auto-recover after a tick so React can clean up
      requestAnimationFrame(() => {
        this.setState({ hasError: false });
      });
    }
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
